import RespectTitlesDeckIMG from "../../assets/DeckCards/Family/RespectTitlesDeckIMG.png";
import ChildrenSiblingsDeckIMG from "../../assets/DeckCards/Family/ChildrenSiblingsDeckIMG.png";
import MaritalFamilyDeckIMG from "../../assets/DeckCards/Family/MaritalFamilyDeckIMG.png";
import ExtendedFamilyDeckIMG from "../../assets/DeckCards/Family/ExtendedFamilyDeckIMG.png";


export const FamilyDeckFace = [

    {
        id: "respect_titles",
        Title: "Respectful Titles",
        Description: "Learn respectful family titles used in Korean households.",
        Difficulty: "Beginner 2",
        Image: RespectTitlesDeckIMG,
        Link: "/RespectfulTitlesDeck",
        cssId: "respect-titles-ID"
    },

    {
        id: "children-siblings",
        Title: "Children & Siblings",
        Description: "Learn words for children, siblings, and close family relations.",
        Difficulty: "Beginner 2",
        Image: ChildrenSiblingsDeckIMG,
        Link: "/ChildrenSiblingsDeck",
        cssId: "children-siblings-ID"
    },

    {
        id: "marital_family",
        Title: "Marital Family",
        Description: "Learn family terms for spouses and in-laws.",
        Difficulty: "Beginner 2",
        Image: MaritalFamilyDeckIMG,
        Link: "/MaritalFamilyDeck",
        cssId: "marital-family-ID"
    },

    {
        id: "extended_family",
        Title: "Extended Family",
        Description: "Learn words for aunts, uncles, cousins, and other relatives.",
        Difficulty: "Beginner 2",
        Image: ExtendedFamilyDeckIMG,
        Link: "/ExtendedFamilyDeck",
        cssId: "extended-family-ID"
    },

];
